import { BaseController } from '~client/controller/base-controller';
import { CityLocationProfile } from '~client/model/city-location-profile';

export class GeoDataController extends BaseController {
  public getCities(query: string): Promise<CityLocationProfile[]> {
    return this.get('/geoData/public/cities', { searchQuery: query });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/geo-data-controller.ts